import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { MinusCircle } from '../../ui/icons';
import { useUnassignDeviceModal } from './useUnassignDeviceModal';

interface IProps {
  deviceDisplayName: string,
  deviceId: string,
  deviceGroupId: string
}

const UnassignDeviceModal = (props: IProps) => {

  const { deviceDisplayName, deviceId, deviceGroupId } = props;
  const { showModel, handleClose, handleShow, handleUnassignButtonClick } = useUnassignDeviceModal({ deviceId, deviceGroupId })

  return (
    <>
      <div onClick={handleShow}>
        Unassign
      </div>

      <Modal show={showModel} onHide={handleClose} className='modal-container unassign-modal' centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className='delete-heading'>
              <MinusCircle></MinusCircle>
              <h1>Unassign Device</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to unassign {deviceDisplayName}?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button className='btn-delete' onClick={handleUnassignButtonClick}>
            Unassign
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UnassignDeviceModal;